/** Decimal coordinate as typed (comma or point), empty allowed (plan decided 2). */
export const INSTALLATION_ADDRESS_DECIMAL_PATTERN = /^-?\d{1,3}([.,]\d+)?$/;

export function isValidInstallationAddressDecimal(value) {
  if (value == null || value === '') {
    return true;
  }

  return INSTALLATION_ADDRESS_DECIMAL_PATTERN.test(String(value));
}

/** Top-level fields the page save leaves out (plan docs/work/_done/2026-10-project-block-customer-installation-address). */
export const PROJECT_CUSTOMER_INSTALLATION_ADDRESS_TOP_LEVEL_FIELDS = [
  'installationAddressState',
  'installationAddress',
];

export const EMPTY_INSTALLATION_ADDRESS = Object.freeze({
  street: '',
  streetNumber: '',
  streetNumberSuffix: '',
  zip: '',
  city: '',
  cityPart: '',
});

/**
 * `ProjectCustomerInstallationAddressInput` from the block object (or the stored project): state,
 * address with empty defaults, flat longitude and latitude from `customer`.
 */
const installationAddressInput = (installationAddress) =>
  Object.fromEntries(
    Object.keys(EMPTY_INSTALLATION_ADDRESS).map((field) => [
      field,
      installationAddress?.[field] ?? '',
    ])
  );

export const toProjectCustomerInstallationAddressInput = (project) => {
  const customer = project.customer ?? {};

  return {
    installationAddressState: project.installationAddressState ?? 'NO',
    installationAddress: installationAddressInput(project.installationAddress),
    longitude: customer.longitude ?? null,
    latitude: customer.latitude ?? null,
  };
};
